import { provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';


platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));


  // import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
// import { AppModule } from './app/app.module';
// import { environment } from './environments/environment';

// checkPortalVersion()
//   .then(version => {
//     if(version === 'NOK'){
//       forceReload()
//     } else {
//       platformBrowserDynamic().bootstrapModule(AppModule)
//         .catch(err => console.error(err))
//     }
//   })
//   .catch(err => {
//     console.error('Version check failed:', err);
//     // If version check completely fails, still try to load the app
//     platformBrowserDynamic().bootstrapModule(AppModule)
//       .catch(err => console.error(err))
//   });

// function forceReload() {
//   // Clear all storage
//   localStorage.clear();
//   sessionStorage.clear();
  
//   // Clear all cookies except version-reload-count
//   document.cookie.split(";").forEach(cookie => {
//     const cookieName = cookie.split("=")[0].trim();
//     if (!cookieName.startsWith('version-reload-count')) {
//       document.cookie = cookieName + "=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
//       document.cookie = cookieName + `=; path=/; domain=${window.location.hostname}; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
//     }
//   });
  
//   // Clear all cache keys
//   if (caches) {
//     caches.keys().then(k => k.forEach(c => caches.delete(c)));
//   }
  
//   // Set reload flag after clearing everything
//   document.cookie = "version-reloading=true; path=/; max-age=60";
  
//   window.location.reload();
// }

// async function checkPortalVersion() {
//   try {
//     // Check if we're in the cookie reload cycle
//     const isReloading = document.cookie.split('; ').find(row => row.startsWith('version-reloading='));
    
//     // Check retry count to prevent infinite loops
//     const reloadCountCookie = document.cookie.split('; ').find(row => row.startsWith('version-reload-count='));
//     const reloadCount = reloadCountCookie ? parseInt(reloadCountCookie.split('=')[1]) : 0;
    
//     // If we've reloaded 5 times, something is wrong with the api so allow app to load even if with old portal version
//     if (reloadCount >= 5) {
//       console.warn('Version check: Maximum reload attempts reached. Loading app anyway.');
//       // Clear the cookies to reset for next session
//       document.cookie = "version-reloading=; path=/; max-age=0";
//       document.cookie = "version-reload-count=; path=/; max-age=0";
//       return 'OK';
//     }
    
//     const versionResponse = await fetch(environment.backend_api_url + "/api/Portal/version", {
//       method: 'GET',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       cache: 'no-cache'
//     });

//     if (!versionResponse.ok) {
//       console.error('Failed to fetch version. Status:', versionResponse.status);
//       // Increment reload count and try to reload
//       document.cookie = `version-reload-count=${reloadCount + 1}; path=/; max-age=300`;
//       return 'NOK';
//     }

//     const version = await versionResponse.json();
//     const versionString = String(version);
//     const localPortalVersion = localStorage.getItem('portal-version');
    
//     // If we just reloaded successfully, save version and clear cookies
//     if (isReloading) {
//       localStorage.setItem('portal-version', versionString);
//       document.cookie = "version-reloading=; path=/; max-age=0";
//       document.cookie = "version-reload-count=; path=/; max-age=0";
//       return 'OK';
//     }

//     // No local version or version mismatch: force reload
//     if (!localPortalVersion || versionString !== localPortalVersion) {
//       // Increment reload count
//       document.cookie = `version-reload-count=${reloadCount + 1}; path=/; max-age=300`;
//       return 'NOK';
//     }

//     // Versions match: clear reload count and continue
//     document.cookie = "version-reload-count=; path=/; max-age=0";
//     return 'OK';

//   } catch (error) {
//     console.error('Error checking portal version:', error);
//     // On network error, increment count and try to reload
//     const reloadCountCookie = document.cookie.split('; ').find(row => row.startsWith('version-reload-count='));
//     const reloadCount = reloadCountCookie ? parseInt(reloadCountCookie.split('=')[1]) : 0;
    
//     if (reloadCount >= 5) {
//       console.warn('Version check: Maximum reload attempts reached after error. Loading app anyway.');
//       document.cookie = "version-reload-count=; path=/; max-age=0";
//       return 'OK';
//     }
    
//     document.cookie = `version-reload-count=${reloadCount + 1}; path=/; max-age=300`;
//     return 'NOK';
//   }
// }